import { RESOLVER_PINS } from "../world-map";

type RowState = "pending" | "ok" | "nxdomain" | "timeout" | "error" | "servfail";
type Row = { resolver: string; state: RowState };

type Props = { rows: Row[] };

function pinClass(state: RowState): string {
  if (state === "ok" || state === "nxdomain") return "pin pin-ok";
  if (state === "timeout" || state === "error" || state === "servfail") return "pin pin-fail";
  return "pin pin-pending";
}

export function WorldMap({ rows }: Props) {
  const stateByResolver = Object.fromEntries(rows.map((r) => [r.resolver, r.state]));

  return (
    <div className="world-map">
      <img
        src="/world-map.svg"
        alt=""
        className="world-map-img"
        width={990}
        height={500}
        decoding="async"
        loading="eager"
        aria-hidden="true"
      />
      <div className="world-map-pins" aria-hidden="true">
        {Object.entries(RESOLVER_PINS).map(([name, pos]) => {
          const state = stateByResolver[name] ?? "pending";
          return (
            <div
              key={name}
              className={pinClass(state)}
              style={{ left: `${pos.left}%`, top: `${pos.top}%` }}
              title={name}
            />
          );
        })}
      </div>
      <ul className="world-map-legend" aria-label="Map legend">
        <li><span className="legend-dot legend-pending" /> Querying</li>
        <li><span className="legend-dot legend-ok" /> Resolved</li>
        <li><span className="legend-dot legend-fail" /> Failed / timeout</li>
      </ul>
    </div>
  );
}
